module.exports = [{"id":0,"lang":"未知类型"},{"id":1,"lang":"常驻活动"},{"id":2,"lang":"常驻活动2"},{"id":3,"lang":"限时活动"},{"id":4,"lang":"限时活动2"},{"id":5,"lang":"版本活动"},{"id":6,"lang":"新兽降临"},{"id":7,"lang":"狂欢活动"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/activity_type.json
// module id = P2OJ
// module chunks = 1